import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const FluidType = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <FormControl fullWidth>
      <InputLabel>Fluid Type</InputLabel>
      <Select
        value={moduleValues?.['Fluid Type'] ?? ''}
        onChange={(e) =>
          setModuleValues((prev) => ({
            ...prev,
            ['Fluid Type']: e.target.value,
          }))
        }
        label="Fluid Type"
      >
        <MenuItem value="Sodium Chloride 0.9%">Sodium Chloride 0.9%</MenuItem>
        <MenuItem value="Hartmann's Solution">Hartmann's Solution</MenuItem>
        <MenuItem value="Sodium Chloride 0.18% / Glucose 4%">
          Sodium Chloride 0.18% / Glucose 4%
        </MenuItem>
        <MenuItem value="Glucose 5%">Glucose 5%</MenuItem>
        <MenuItem value="Glucose 10%">Glucose 10%</MenuItem>
      </Select>
    </FormControl>
  </Grid>
)

export default FluidType
